import React, { Component } from 'react';
import { withRouter } from "react-router";
import TitleBar from './TitleBar';
import bibleJson from "../utils/bible";


class JournalPromptSelected extends Component{
  constructor(props) {
    super(props);
    this.state = {
      chapter: this.props.match.params.chapter,
      verses: parseInt(this.props.match.params.verses) - 1,
      verse: parseInt(this.props.match.params.verse) - 1
    }
  }

  render() {  
    const { chapter, verses, verse } = this.state;

    const chapterFound = bibleJson.find( c => {
      return c.abbrev === chapter
    })

    const versesDisplay = verses + 1;
    const verseDisplay =  verse + 1;

    return(
      <div className="journalPrompt">
        <TitleBar title={chapterFound.name + " " + versesDisplay + "-" + verseDisplay} content={"Write a journal for " + chapterFound.name + " " + versesDisplay + "-" + verseDisplay} />
        <div className="Container Container--md Container--side-padding Container-vc">
          <div className="ui-box fade-up">
            <div className="journal-prompt">
              <h1>{chapterFound.chapters[verses][verse]}</h1>
              <p><code style={{ color: '#999' }}>{chapterFound.name + " " + versesDisplay + "-" + verseDisplay}</code></p>

                <button 
                  className="cta-btn btn-happy"
                  id="journalPrompt_write"
                  onClick={() => window.location = 'https://app.goodnightjournal.com/write?journalPrompt=' + chapterFound.chapters[verses][verse] + " " + chapterFound.name + " " + versesDisplay + "-" + verseDisplay}>
                    Write about it
                </button>

            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(JournalPromptSelected)